import React, { Component } from "react";
import {
  Container,
  Col,
  Row,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  FormGroup,
  Label,
  Input,
  DropdownItem,
  Form,
} from "reactstrap";
import "bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import httpClient from "../../../httpClient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faSearch } from "@fortawesome/free-solid-svg-icons";
import Calender from '../calender';
import {redirect, volFilter} from '../../../slices/filterSlice'
import '../../../style/css/particulier/hebergement.css'
import { barFilter } from "../../../slices/volSearchBarSlice";


class AdvencedSearchVols extends Component {
  constructor(props) {
    super(props);
    this.state= {
      VolFilter: {num:this.props.num,volReturn:true,departPlace:"",departCode:"",arriveCode:"", arrivePlace:"",dateDepart:this.props.startDate, dateArrive:this.props.endDate, origin:"",destination:"",escale:false},
      autocompletePlaces:[],
      menuInputDepart:false,
      menuInputArrive:false,
      multiple:false,
      nbCity : 1,
      volClass : "Economy",
      dateExacte: "Date exacte",
      traveler: "Passagers",
      nbrTravaler : 1,
      adult: 1,
      enf : 0,
      baby : 0,
      student : 0,
      senior : 0,
      marin : 0
    }
      this.cityCodeArrive = this.cityCodeArrive.bind(this);

  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.VolFilter !== this.state.VolFilter) {
      this.props.dispatch(barFilter(this.state.VolFilter))
      this.props.dispatch(redirect(true))
    }
  }

  onInputChange(evt) {
    try {
      this.setState({
        VolFilter: {
          ...this.state.VolFilter,
          [evt.target.name]: evt.target.type === "checkbox" ? evt.target.checked : evt.target.value 
        }
      })
    } catch (error) {
      console.log(error);
    }

	}

  cityCodeDepart(e,city,code,name){
    e.preventDefault()

    this.setState({
      VolFilter: {
        ...this.state.VolFilter,
        departPlace: city,
        departCode:code,
        origin:name
      },
      menuInputDepart:false
    })
  }
  cityCodeArrive(e,city,code,name){
    e.preventDefault()

    this.setState({
      VolFilter: {
        ...this.state.VolFilter,
        arrivePlace: city,
        arriveCode:code,
        destination:name
      },
      menuInputArrive:false

    })
}

autoCompleteClose(evt){
    evt.preventDefault()
      this.setState({
        [evt.target.id]: false
      })
    
}
autoCompleteOpen(evt){
  evt.preventDefault()
    this.setState({
      [evt.target.id]: true
    }) 
}

  autoComplete(evt) {
    try {
      evt.preventDefault()
      if ((evt.target.name==='departPlace'||evt.target.name==='arrivePlace') ) {

        this.setState({
          [evt.target.id]: true
        })

        httpClient.autocompletePlaces(evt.target.value).then((res)=>{
          if (res){
            this.setState({autocompletePlaces:res.data})
          }

        })
      }
    } catch (error) {
      console.log(error);
    }

  }
  
  render() {
  
    const citiesDepart = this.state.autocompletePlaces.map((city,i)=>{
      const name = city.name ;
      const code = city.address.cityCode;
      const country = city.address.countryCode;
      return (
       <DropdownItem className="pl-1" id={`cityDep`+i} key={city.address.cityCode} onMouseDown={e=>{this.cityCodeDepart.bind(this)(e,`${name} (${code}, ${country})`,code,name)}} ><FontAwesomeIcon  icon={faMapMarkerAlt} name={city.address.cityCode}/> {name} ({code}, {country})</DropdownItem>
      )},this)

    const citiesArrive = this.state.autocompletePlaces.map((city,i)=>{
      const name = city.name ;
      const code = city.address.cityCode;
      const country = city.address.countryCode;
      return (<DropdownItem className="pl-1" id={`cityArr`+i} key={city.address.cityCode} onMouseDown={e=>{this.cityCodeArrive.bind(this)(e,`${name} (${code}, ${country})`,code,name)}}><FontAwesomeIcon  icon={faMapMarkerAlt} name={city.address.cityCode}/> {name} ({code}, {country})</DropdownItem>
    )},this)

    const {menuInputDepart,menuInputArrive} = this.state ;
    const {departPlace,arrivePlace} = this.state.VolFilter ;
    const volReturn = this.state.VolFilter.volReturn ;

    return (
      <Container onChange={this.onInputChange.bind(this)} >
        
        <Row className="pl-3 pr-2">
              
              <Col className=" col-12 col-md-6 col-lg-3 px-0 ">
                <div>
                  <UncontrolledDropdown nav inNavbar>
                    <input onInput={this.autoComplete.bind(this)} onFocus={(e)=> this.autoCompleteOpen.bind(this)(e)} onBlur={(e)=> this.autoCompleteClose.bind(this)(e)} value={departPlace} type="text" name="departPlace" id="menuInputDepart" className="filter-element left-radius" placeholder=" Départ" autoComplete='off' required/>                      
                    <DropdownMenu className={`${menuInputDepart&&'show'} destination-drop-down`}>
                    <div>
                          <div className="body-drop-down">
                          
                          <div><FontAwesomeIcon id="search-result" icon={faSearch} /><span id="reslt-title"> Résultat</span></div>
                            
                            <hr />
                            <div className="result-block"> 
                            {citiesDepart}
                             </div>
                            <span id="recent-title">Récents</span>
                             <hr />
                             <div className="result-block">
                             <div className="recent"><FontAwesomeIcon  icon={faSearch} /> Paris,France</div>
                             <div className="recent"><FontAwesomeIcon  icon={faSearch} /> Ibiza,Espagne</div>
                             <div className="recent"><FontAwesomeIcon  icon={faSearch} /> Dubai,UAE</div>
                             </div>
                             </div>
                        </div>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </Col>

              <Col className=" mb-1 col-12 col-md-6 col-lg-3 px-0">
                <div  className="destination-input mb-1">
                  <UncontrolledDropdown nav inNavbar>
                    <input type="text" name="arrivePlace" onInput={this.autoComplete.bind(this)} onFocus={(e)=> this.autoCompleteOpen.bind(this)(e)} onBlur={(e)=> this.autoCompleteClose.bind(this)(e)} id="menuInputArrive" value={arrivePlace} className="filter-element" placeholder=" Arrive" autoComplete='off' required/>                      
                    <DropdownMenu className={`${menuInputArrive&&'show'} destination-drop-down`}>
                    <div>
                          <div className="body-drop-down">
                          
                          <div><FontAwesomeIcon id="search-result" icon={faSearch} /><span id="reslt-title"> Résultat</span></div>
                            
                            <hr />
                            <div className="result-block"> {citiesArrive} </div>
                            <span id="recent-title">Récents</span>
                             <hr />
                             <div className="result-block">
                             <div className="recent"><FontAwesomeIcon  icon={faSearch} /> Paris,France</div>
                             <div className="recent"><FontAwesomeIcon  icon={faSearch} /> Ibiza,Espagne</div>
                             <div className="recent"><FontAwesomeIcon  icon={faSearch} /> Dubai,UAE</div>
                             </div>
                             </div>
                        </div>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </Col>

              <Col className=" mb-1 col-12 col-md-12 col-lg-4 px-0 ">
                <div style={{marginTop:"1px"}}>
               
                    <Calender returnBool={volReturn} num={this.props.num}/>
     
                </div>
              </Col>

              <div className=" mb-1 col-12 col-lg-2">
              <div >
                  <UncontrolledDropdown   nav inNavbar>
                    <DropdownToggle
                      id="destination"
                      className="Advanced-btn-ser pr-2 pl-0  filter-element font-weight-bold "
                    >
                     {this.state.dateExacte }               
                      <img className="ml-2"
                        src="/imgs/navebar/downArrow.svg"
                        alt="parcouri"
                        id="arrow-parcourir-big"
                      />
                    </DropdownToggle>
                     <DropdownMenu className="destination-drop-down">
                        <DropdownItem value="-1 et +1" onMouseDown={(e)=>this.setState({dateExacte: e.target.value})} >-1 et +1</DropdownItem>
                        <DropdownItem value="-2 et +2" onMouseDown={(e)=>this.setState({dateExacte: e.target.value})} >-2 et +2</DropdownItem>
                        <DropdownItem value="-3 et +3" onMouseDown={(e)=>this.setState({dateExacte: e.target.value})} >-3 et +3</DropdownItem>
                        <DropdownItem value="Date exacte" onMouseDown={(e)=>this.setState({dateExacte: e.target.value})} >Date exacte</DropdownItem>
                      </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </div>
        </Row>
    

        <div className="body-vol"></div>
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    startDate: state.date.startDate,
    endDate: state.date.endDate,
    vol: state.volBarFilter.VolFilter,
    multiDest:state.volBarFilter.multiDest
  }
}
export default withRouter(connect(mapStateToProps)(AdvencedSearchVols
));

